import { render, staticRenderFns } from "./GroupPanel.vue?vue&type=template&id=0cb2af11&scoped=true&"
import script from "./GroupPanel.vue?vue&type=script&lang=js&"
export * from "./GroupPanel.vue?vue&type=script&lang=js&"
import style0 from "./GroupPanel.vue?vue&type=style&index=0&id=0cb2af11&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb2af11",
  null
  
)

export default component.exports